<ng-container *ngIf="batteryState === EAssetBatteryState.Empty">
  <ng-container *ngTemplateOutlet="emptyBatteryWarning"></ng-container>
</ng-container>
<span i18n="@@S_ASSET_BALLOON_BATTERY_SECTION_HEADER" class="battery-header">Asset tracker battery</span>
<ng-container *ngIf="batteryState !== EAssetBatteryState.Missing">
  <ng-container *ngTemplateOutlet="batteryLevel"> </ng-container>
</ng-container>

<span *ngIf="batteryState === EAssetBatteryState.Missing" class="no-battery-info" i18n="@@S_ASSET_BALLOON_NO_BATTERY_INFO"
  >No battery information available</span
>

<ng-template #batteryLevel>
  <div class="battery-level">
    <mat-progress-bar
      class="progress-bar"
      [class.progress-bar--low-level]="batteryState === EAssetBatteryState.Low"
      mode="determinate"
      [value]="roundedBatteryPercentage"
    ></mat-progress-bar>
    <div class="progress-bar__battery-head"></div>
    <span class="battery-level__percentage">{{ roundedBatteryPercentage }}%</span>
    <ng-container [ngSwitch]="batteryState">
      <a
        *ngSwitchCase="EAssetBatteryState.Low"
        class="help-url"
        href="{{ batteryReplacementHelpUrl }}"
        target="_blank"
        i18n="@@S_ASSET_BALLOON_LOW_BATTERY"
        rel="noopener"
        >Battery low</a
      >
      <a
        *ngSwitchCase="EAssetBatteryState.Empty"
        class="help-url"
        href="{{ batteryReplacementHelpUrl }}"
        target="_blank"
        i18n="@@S_ASSET_BALLOON_LOW_EMPTY"
        rel="noopener"
        >Battery empty</a
      >
    </ng-container>
  </div>
</ng-template>

<ng-template #emptyBatteryWarning>
  <div class="empty-battery-warning">
    <mat-icon class="empty-battery-warning__icon mat-icon-size-xs" svgIcon="ic-health-status-critical"></mat-icon>
    <span i18n="@@S_ASSET_BALLOON_LOW_EMPTY_MESSAGE">The asset tracker battery is empty.</span>
  </div>
</ng-template>
